import { map } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'nearpayTerminal',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET NearpayTerminalS
    getNearpayTerminalsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },

    // GET NearpayTerminal
    getNearpayTerminalSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },

    // UPDATE NearpayTerminal
    updateNearpayTerminalSuccess(state, action) {
      state.record = action.payload;
      const updateRecord = map(state.data, (_record) => {
        if (_record.id === state.record.id) {
          return state.record;
        }
        return _record;
      });

      state.isLoading = false;
      state.data = updateRecord;
      state.params = { ...state.params };
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },

    // REFRESH PARAMS
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getNearpayTerminals(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/nearpay-terminal/', {
        params,
      });
      dispatch(slice.actions.getNearpayTerminalsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function refreshNearpayTerminals(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/nearpay-terminal/refresh/', {
        params,
      });
      dispatch(slice.actions.getNearpayTerminalsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getNearpayTerminal(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/nearpay-terminal/${id}/`);
      dispatch(slice.actions.getNearpayTerminalSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateNearpayTerminal(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/nearpay-terminal/${id}/`, record);
      dispatch(slice.actions.updateNearpayTerminalSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function partialUpdateNearpayTerminal(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`/nearpay-terminal/${id}/`, record);
      dispatch(slice.actions.updateNearpayTerminalSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
